import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

const CardListItemElement = props => {
  const className = clsx(
    `block w-full px-4 py-3 last:pr-0 h-full flex-grow-0 flex-shrink-0 flex-basis-auto truncate outline-none`,
    {
      'max-w-[100px]': !props.size || props.size === 'small',
      'max-w-[120px]': props.size === 'medium',
      'max-w-[160px]': props.size === 'large',
      'max-w-[200px]': props.size === 'xl',
      'max-w-[240px]': props.size === '2xl',
      'max-w-[280px]': props.size === '3xl',
      'max-w-[320px]': props.size === '4xl',
      'max-w-full flex-shrink-1 min-w-[160px]': props.size === 'fill',
      'ml-auto': props.align === 'right',
      'mr-auto': props.align === 'left',
      'text-right': props.textAlign === 'right',
      'text-left': props.textAlign !== 'right',
    },
    props.className,
  );

  const Component = props.href ? Link : 'div';

  return <Component {...props} className={className} to={props.href} />;
};

export default CardListItemElement;
